import { render, staticRenderFns } from "./item-card.vue?vue&type=template&id=1bcbaf02&scoped=true&"
import script from "./item-card.vue?vue&type=script&lang=js&"
export * from "./item-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbaf02",
  null
  
)

export default component.exports